import React, { Component, ErrorInfo, ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null; errorInfo: ErrorInfo | null };

export class ContentErrorBoundary extends Component<Props, State> {
  state: State = { error: null, errorInfo: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ errorInfo });
    console.error('Content render error:', error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="alert alert-danger d-flex align-items-center p-5">
          <div className="d-flex flex-column">
            <h5 className="mb-2">Content could not be displayed</h5>
            <p className="mb-1 text-muted small">{this.state.error.message}</p>
            {this.state.errorInfo?.componentStack && (
              <pre className="small bg-light p-3 mt-2 overflow-auto" style={{ maxHeight: 200 }}>
                {this.state.errorInfo.componentStack}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
